import {MAPS_KEY, MAPS_STORAGE_IDENTIFIER} from '$c3local/constants.js';

let filter;

function createFilter() {
    if (!filter) {
        const jobContainer = $('.job-list');
        const jobs = jobContainer.find('.job');
        filter = (cb) => {
            jobs.each(function () {
                const j = $(this);
                const show = cb(j);
                j.parent().toggleClass('job-hidden', !show);
            });
        };
    }
    return filter;
}

export function initRecruitingSearch() {
    const input = $('#jobs-title');
    const filterJobs = createFilter();

    $('.job-list-search').submit(function (e) {
        e.preventDefault();
        const search = input.val().toLowerCase();
        if (search === '') {
            filter(() => true);
            return;
        }

        filterJobs(job => {
            const title = job.find('.job-title').text().toLowerCase();
            const subtitle = job.find('.job-subtitle').text().toLowerCase();
            return title.includes(search) || subtitle.includes(search);
        });
    });
}

export async function initRecruitingFilters() {
    const form = $('.job-list-filter');

    if (!form.length) {
        return;
    }

    const premiumFilter = $('#jobs-filter-premium');
    const employmentTypeFilter = $('#jobs-filter-employment-type');
    const tagFilter = $('#jobs-filter-tag');
    const sponsorFilter = $('#jobs-filter-sponsor');
    const locationField = $('#jobs-filter-location');
    const locationClear = $('#jobs-filter-location-clear');
    const filterJobs = createFilter();
    let location;

    const mapsEnabled = localStorage.getItem(MAPS_STORAGE_IDENTIFIER) === 'true';
    if (mapsEnabled) {
        _loadMaps().catch(console.error);
    } else {
        locationField.one('focus', function () {
            $(this).parents('.form-field')
                .addClass('form-field-overlay-active');
            $(this).val('');
            this.blur();
        });

        const allowBtn = $('#jobs-filter-location-allow-google');
        allowBtn.one('click', function () {
            $(this).parents('.form-field')
                .removeClass('form-field-overlay-active');
            localStorage.setItem(MAPS_STORAGE_IDENTIFIER, 'true');
            _loadMaps().catch(console.error);
        });
    }

    locationClear.click(function () {
        locationField.val('');
        location = undefined;
        _doFilter();
    });


    [employmentTypeFilter, tagFilter, sponsorFilter, premiumFilter].forEach(filter => {
        filter.change(function () {
            form.trigger('submit');
        });
    });

    form.submit(function (e) {
        e.preventDefault();
        _doFilter();
    });

    function _doFilter() {
        const tag = parseInt(tagFilter.val());
        const employmentType = employmentTypeFilter.val();
        const sponsor = parseInt(sponsorFilter.val());
        const locationQuery = locationField.val();
        const premium = parseInt(premiumFilter.val());

        filterJobs(job => {
            const jobTags = job.data('tags');
            const jobEmploymentType = job.data('employment-type');
            const jobSponsor = job.data('sponsor');
            const jobCoords = job.data('coords');
            const jobPremium = job.data('premium');
            const tagMatches = jobTags.includes(tag) || tag === -1 || isNaN(tag);
            const employmentTypeMatches = employmentType === jobEmploymentType || employmentType === '-1';
            const premiumMatches = jobPremium === premium || premium === -1 || isNaN(premium);

            let sponsorMatches;
            if (isNaN(sponsor)) {
                sponsorMatches = true;
            } else {
                sponsorMatches = sponsor === jobSponsor || sponsor === -1;
            }

            let locationInRange = false;
            if (location) {
                if (jobCoords) {
                    const coords = `${location.lat},${location.lng}`;
                    for (const entry of jobCoords.split('|')) {
                        const distance = geoDistance(entry, coords);
                        if (distance < 50) {
                            locationInRange = true;
                            break;
                        }
                    }
                } else {
                    locationInRange = false;
                }
            } else {
                locationInRange = true;
            }

            return tagMatches && employmentTypeMatches && sponsorMatches && locationInRange && premiumMatches;
        });
    }

    async function _loadMaps() {
        if (!locationField.length) {
            return;
        }

        const {Loader} = await import('$c3local/Lib/google-maps/Loader.js');

        const loader = new Loader({
            apiKey: MAPS_KEY,
            version: 'weekly',
            libraries: ['places']
        });

        const google = await loader.load();

        const searchBox = new google.maps.places.Autocomplete(locationField[0], {
            componentRestrictions: {
                country: 'de'
            }
        });

        searchBox.addListener('place_changed', () => {
            const place = searchBox.getPlace();

            if (!place?.geometry?.location) {
                console.log('Returned place contains no geometry');
                return;
            }

            location = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            };

            _doFilter();
        });
    }
}

function geoDistance(origin, destination) {
    const from = origin.split(',');
    const to = destination.split(',');
    const R = 6371; // km
    const lat1 = parseFloat(from[0]),
        lon1 = parseFloat(from[1]),
        lat2 = parseFloat(to[0]),
        lon2 = parseFloat(to[1]);
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    // Distance in km
    return R * c;
}

function toRad(num) {
    return num * Math.PI / 180;
}